<template>
  <div class="layout-header">
    <div class="layout-title">
      {{ headerTitle }}
      <slot name="header-title-action"></slot>
    </div>
    <div class="layout-header-actions">
      <slot name="header-actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "reference-header",
  props: {
    headerTitle: {
      type: String,
      default: () => "Заголовок справочника",
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-header {
  @media (max-width: 768px) {
    margin-bottom: 23px;
  }
  @media screen and (max-width: 639px) {
    flex-direction: column;
    margin-bottom: 5rem;
  }
}
.layout-title {
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  margin-right: 5px;
  align-items: center;
  @media screen and (max-width: 639px) {
    width: 100%;
  }
}
.layout-header-actions {
  display: flex;
  @media (max-width: 639px) {
    margin-top: 16px;
  }
}
</style>
